

































































import {
  defineComponent,
  ref,
  PropType,
  watch,
  computed,
} from '@vue/composition-api';
import { DisplayableWord } from '@oare/types';
import sl from '@/serviceLocator';
import AddWordDialog from './components/AddWordDialog.vue';

export default defineComponent({
  name: 'Dictionary',
  components: {
    AddWordDialog,
  },
  props: {
    wordList: {
      type: Array as PropType<DisplayableWord[]>,
      required: true,
    },
    letter: {
      type: String,
      required: true,
    },
    route: {
      type: String,
      required: true,
    },
    searchFilter: {
      type: Function as PropType<
        (search: string, word: DisplayableWord) => boolean
      >,
      required: true,
    },
    filterTitle: {
      type: String,
      default: 'words',
    },
  },
  setup(props) {
    const store = sl.get('store');
    const addWordDialog = ref(false);
    const filteredWords = ref<DisplayableWord[]>(props.wordList);
    const canAddWords = computed(() => store.hasPermission('ADD_LEMMA'));

    const filterWords = (search: string) => {
      filteredWords.value = props.wordList.filter(word =>
        props.searchFilter(search, word)
      );
    };

    const highlight = [
      { bin: '0-10', color: '#caf0f8' },
      { bin: '11-100', color: '#90e0ef' },
      { bin: '101-1000', color: '#e0aaff' },
      { bin: '1001-10000', color: '#c77dff' },
      { bin: '10001-25000', color: '#ffccd5' },
      { bin: '25001+', color: '#ff8fa3' },
    ];

    const addWordKey = ref(false);
    watch(addWordDialog, () => {
      if (addWordDialog.value) {
        addWordKey.value = !addWordKey.value;
      }
    });

    return {
      filteredWords,
      filterWords,
      highlight,
      addWordDialog,
      addWordKey,
      canAddWords,
    };
  },
});
